"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const commonParamBuilder_1 = require("./commonParamBuilder");
const base_jsbridge_1 = require("@ali/base-jsbridge");
require("@ali/uc-intl-news-jssdk");
const queryString = require("query-string");
let QueryParams;
window.queryString = queryString;
function generateUUID() {
    let d = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // tslint:disable-next-line:no-bitwise
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        // tslint:disable-next-line:no-bitwise
        return (c === 'x' ? r : (r & 0x7 | 0x8)).toString(16);
    });
    return uuid;
}
exports.generateUUID = generateUUID;
function getQueryParams() {
    if (!QueryParams) {
        const params = queryString.parse(window.location.search);
        Object.keys(params).forEach((key) => {
            if (Array.isArray(params[key])) {
                params[key] = params[key].pop();
            }
        });
        if (!params.ver && params.ve) {
            params.ver = params.ve;
        }
        if (params.app === 'vidchat') {
            params.app = 'blower_iflow';
        }
        if (params.sv && !params.sver) {
            params.sver = params.sv;
        }
        QueryParams = params;
        return params;
    }
    else {
        return QueryParams;
    }
}
exports.getQueryParams = getQueryParams;
function getNetworkType() {
    if (getClient() === 'vidchat') {
        return this.getCommenParamsFromVidchat().then((data) => {
            return data.nw;
        }).catch(() => {
            return 'unknow';
        });
    }
    return callJssdk('alphaNews.generateUcParamFromUrl', {
        url: '?uc_param_str=nw',
    }).then((data) => {
        if (data && data.url) {
            return (queryString.parse(data.url).nw || 'unknow');
        }
        else {
            return 'unknow';
        }
    }).catch(() => {
        return 'unknow';
    });
}
exports.getNetworkType = getNetworkType;
let JSSDK_COMMON_PARAMS = null;
function getCommonParamsFromJssdk() {
    if (JSSDK_COMMON_PARAMS) {
        return Promise.resolve(JSSDK_COMMON_PARAMS);
    }
    if (getClient() === 'vidchat') {
        return this.getCommenParamsFromVidchat().then((data) => {
            if (data && data.app) {
                JSSDK_COMMON_PARAMS = data;
                return JSSDK_COMMON_PARAMS;
            }
            return {};
        }).catch(() => {
            return {};
        });
    }
    return callJssdk('alphaNews.generateUcParamFromUrl', {
        url: '?uc_param_str=' + commonParamBuilder_1.ucParamStr,
    }).then((data) => {
        if (data && data.url) {
            JSSDK_COMMON_PARAMS = queryString.parse(data.url);
            return JSSDK_COMMON_PARAMS;
        }
        return {};
    }).catch(() => {
        return {};
    });
}
exports.getCommonParamsFromJssdk = getCommonParamsFromJssdk;
function getCommenParamsFromVidchat() {
    return base_jsbridge_1.invoke('biz.getUCParams', { params: commonParamBuilder_1.ucParamStr }).then((data) => {
        if (data && data.app) {
            const transNWStatus = function (nw) {
                switch (nw) {
                    case 6:
                        return '4G';
                    case 5:
                        return 'WIFI';
                    case 4:
                        return '3G';
                    case 2:
                        return '2.5G';
                    case 1:
                        return '2G';
                    default:
                        return 'unknow';
                }
            };
            return Object.assign(Object.assign({}, data), { app: data.app, ve: data.ve, ver: data.ve, entry: data.entry1, ct_lang: data.set_lang, lang: data.set_lang, sver: data.sv, nt: data.nw, nw: transNWStatus(+data.nw) });
        }
    });
}
exports.getCommenParamsFromVidchat = getCommenParamsFromVidchat;
function getQueryParam(key) {
    return getQueryParams()[key];
}
exports.getQueryParam = getQueryParam;
function getReferrer() {
    const referrer = document.referrer;
    if (!referrer) {
        return 'direct';
    }
    if (referrer.indexOf('http') === 0) {
        if (referrer.indexOf('/') !== -1) {
            const referrers = referrer.split('/');
            if (referrers.length >= 3) {
                return referrers[0] + '//' + referrers[2];
            }
        }
        return 'http';
    }
    if (referrer.indexOf('file') === 0) {
        return 'file';
    }
    return 'unknow';
}
exports.getReferrer = getReferrer;
function getArticleId() {
    const params = getQueryParams();
    if (params.id) {
        return params.id;
    }
    if (params.item_id) {
        return params.item_id;
    }
    if (params.ucnews_item_id) {
        return params.ucnews_item_id;
    }
    const regex = /story\/(\d+)/;
    const regex2 = /\/(\d+)$/;
    if (regex.test(window.location.pathname)) {
        return (window.location.pathname).match(/story\/(\d+)/)[1];
    }
    if (regex2.test(window.location.pathname)) { // 短内容
        return (window.location.pathname).match(regex2)[1];
    }
    return null;
}
exports.getArticleId = getArticleId;
function getCommonParams() {
    const params = getQueryParams();
    return commonParamBuilder_1.commonParamBuilder.getParams(params);
}
exports.getCommonParams = getCommonParams;
function getCommonParamsStr(extraParams = {}, filterEmptyFiled = true) {
    const params = commonParamBuilder_1.commonParamBuilder.getParams(getQueryParams());
    const stringifyParams = Object.assign({}, params, extraParams);
    if (filterEmptyFiled) {
        Object.keys(stringifyParams).forEach((key) => {
            if (stringifyParams[key] === '' || stringifyParams[key] === undefined || stringifyParams[key] === null) {
                delete stringifyParams[key];
            }
        });
    }
    return queryString.stringify(stringifyParams);
}
exports.getCommonParamsStr = getCommonParamsStr;
function callJssdk(method, options) {
    return new Promise((resolve, reject) => {
        if (window && window.ucapi) {
            const methods = method.split('.');
            let invokeMethod;
            for (let i = 0; i < methods.length; i++) {
                if (invokeMethod === undefined && i === 0) {
                    invokeMethod = window.ucapi[methods[i]];
                }
                else if (invokeMethod) {
                    invokeMethod = invokeMethod[methods[i]];
                }
            }
            if (invokeMethod) {
                invokeMethod(Object.assign(options, {
                    success: (data) => {
                        resolve(data);
                    },
                    fail: (err) => {
                        reject(err);
                    },
                }));
            }
            else {
                reject(new Error(`ucapi ${method} not defined`));
            }
        }
        else {
            reject(new Error('ucapi not defined'));
        }
    });
}
exports.callJssdk = callJssdk;
function getClient() {
    const ua = window.navigator.userAgent;
    if (ua && /.+UCNewsApp.+/i.test(ua)) {
        return 'app';
    }
    else if (ua && /.+UCNEWSINTL.+/i.test(ua)) {
        return 'app';
    }
    else if (ua && (/.+UCBrowser.+/i.test(ua) || /.+UCMiniIflow.+/i.test(ua))) {
        return 'ucbrowser';
    }
    else if (ua && (/.+vidchat.+/i.test(ua))) {
        return 'vidchat';
    }
    else {
        return 'other';
    }
}
exports.getClient = getClient;
function getLogApp() {
    const queries = getQueryParams();
    if (queries.uc_news_app && queries.uc_news_app_entry && queries.uc_news_app_entry.indexOf('cricket') !== -1) {
        return queries.uc_news_app;
    }
    if (queries.stat_app) {
        return queries.stat_app;
    }
    const client = getClient();
    if (!queries.app && client) {
        if (client === 'ucbrowser') {
            queries.app = 'browser_iflow';
        }
        else if (client === 'app') {
            queries.app = 'app_iflow';
        }
    }
    return queries.app;
}
exports.getLogApp = getLogApp;
function sendEvent(name, data) {
    const event = document.createEvent('Event');
    // 事件的初始化
    event.initEvent(name, true, true);
    // 事件传参
    event.data = data;
    // 触发事件
    document.dispatchEvent(event);
}
exports.sendEvent = sendEvent;
function urlQuery(key) {
    return getCommonParams()[key] || null;
}
exports.urlQuery = urlQuery;
function initLoading(id) {
    const el = document.getElementById(id);
    el.innerHTML = `<div class="progress round-conner">
                      <div class="curRate round-conner"></div>
                    </div>`;
    return () => {
        el.innerHTML = '';
    };
}
exports.initLoading = initLoading;
function makeUrl(url, params) {
    for (const key in params) {
        if (params[key]) {
            if (url.indexOf('?') === -1) {
                url += '?';
            }
            else {
                url += '&';
            }
            url += key + '=' + params[key];
        }
    }
    return url;
}
exports.makeUrl = makeUrl;
function makeImageUrl(imageUrl, options = {
    ext: '',
}) {
    const imageCoundHost = ['ucweb.com', 'uodoo.com', 'newsstripe.com', 'inibaruberita.com', 'headlinecamp.com', 'ncloudpicture.com', 'vmate.in'];
    const findHost = imageCoundHost.find((host) => {
        if (/(img.(ucweb|uodoo).com)\/s\//.test(imageUrl)) {
            return false;
        }
        return imageUrl && imageUrl.indexOf(host) !== -1;
    });
    if (findHost) {
        return `${imageUrl};,${options.quality || ''},${options.ext || ''};${options.op && options.op.map((item) => item.toOp()).join(';')}`;
    }
    return imageUrl;
}
exports.makeImageUrl = makeImageUrl;
function imageOP() {
    return {
        zoom: (size, isBatch) => {
            return {
                toOp() {
                    return `3,${size.join('')}${isBatch ? ',1' : ','}`;
                },
            };
        },
        crop: (size, startPos, forceScale, isBatch) => {
            return {
                toOp() {
                    return `6,${startPos ? startPos.join('') : ''},${size.join('')},${forceScale ? '1' : ''},${isBatch ? '1' : ''}`;
                },
            };
        },
    };
}
exports.imageOP = imageOP;
function formatTime(time, justnow) {
    const nowTime = Date.now();
    const timeSpan = (nowTime - time) / 1000;
    let renderText = '';
    if (timeSpan < 60) {
        renderText = justnow || 'justnow';
    }
    else if (timeSpan < 3600) {
        renderText = Math.floor(timeSpan / 60) + ' m'; // 精简时间格式
    }
    else if (timeSpan < 24 * 3600) {
        renderText = Math.floor(timeSpan / 3600) + ' h'; // 精简时间格式
    }
    else {
        const originalTime = new Date(time);
        const month = originalTime.getMonth() + 1;
        const day = originalTime.getDate();
        const hour = originalTime.getHours();
        const minute = originalTime.getMinutes();
        const monthStr = `${month < 10 ? '0' : ''}${month}`;
        const dayStr = `${day < 10 ? '0' : ''}${day}`;
        const hourStr = `${hour < 10 ? '0' : ''}${hour}`;
        const minuteStr = `${minute < 10 ? '0' : ''}${minute}`;
        renderText = monthStr + '-' + dayStr + ' ' + [hourStr, minuteStr].join(':'); // 精简时间格式
    }
    return renderText;
}
exports.formatTime = formatTime;
/*
* 格式化时间
* 参数:
* timeStamp: 时间戳
* format: 时间格式, 年: YYYY | YY, 月: MM, 日: DD, 时: hh, 分: mm, 秒: ss
*       YYYY-MM-DD | MM-DD hh:mm | hh:mm:ss MM-DD-YYYY | ...
* 返回：
* 不传format时返回: [YYYY, MM, DD, hh, mm, ss], 传format则根据format返回对应字符串
*/
function formatTimeV2(timeStamp, format) {
    const time = new Date(timeStamp);
    const year = time.getFullYear();
    const month = time.getMonth() + 1;
    const day = time.getDate();
    const hour = time.getHours();
    const minute = time.getMinutes();
    const seconds = time.getSeconds();
    const sp = (t) => t > 9 ? '' + t : '0' + t;
    if (format) {
        return format.replace(/(YYYY|YY|MM|DD|hh|mm|ss)/g, function (match) {
            switch (match) {
                case 'YYYY':
                    return '' + year;
                case 'YY':
                    return ('' + year).substr(2);
                case 'MM':
                    return sp(month);
                case 'DD':
                    return sp(day);
                case 'hh':
                    return sp(hour);
                case 'mm':
                    return sp(minute);
                case 'ss':
                    return sp(seconds);
            }
        });
    }
    else {
        return ['' + year, sp(month), sp(day), sp(hour), sp(minute), sp(seconds)];
    }
}
exports.formatTimeV2 = formatTimeV2;
// 外国数字常用显示方式，从右向左逢3位加个逗号，如：1,760,049、3,213,090,132
function splitNumber(num) {
    return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
exports.splitNumber = splitNumber;
function preventDefault(Fn, ...args) {
    return function (e) {
        e.preventDefault();
        e.stopPropagation();
        return Fn(...args);
    };
}
exports.preventDefault = preventDefault;
function getScrollTop() {
    return document.documentElement.scrollTop || document.body.scrollTop;
}
exports.getScrollTop = getScrollTop;
function getScrollHeight() {
    return document.documentElement.scrollHeight || document.body.scrollHeight;
}
exports.getScrollHeight = getScrollHeight;
//# sourceMappingURL=data:application/json;base64,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